import { ClassTable } from './ClassTable';
export default ClassTable;
